const SESSION_STORAGE_KEYS = [
  "token",
  "companyId",
  "userId",
  "companyDueDate",
  "cshow",
];

const authStateHandlers = new Set();
const apiCleanupHandlers = new Set();
const socketCleanupHandlers = new Set();

let invalidationPromise = null;

const runHandlers = (handlers, payload) => {
  handlers.forEach((handler) => {
    try {
      handler(payload);
    } catch (error) {
      console.error("[session] error while running invalidation handler", error);
    }
  });
};

export const registerAuthStateHandler = (handler) => {
  authStateHandlers.add(handler);
  return () => authStateHandlers.delete(handler);
};

export const registerApiCleanupHandler = (handler) => {
  apiCleanupHandlers.add(handler);
  return () => apiCleanupHandlers.delete(handler);
};

export const registerSocketCleanupHandler = (handler) => {
  socketCleanupHandlers.add(handler);
  return () => socketCleanupHandlers.delete(handler);
};

export const invalidateSession = ({ reason = "unknown", redirectTo = "/login" } = {}) => {
  if (invalidationPromise) {
    return invalidationPromise;
  }

  invalidationPromise = Promise.resolve().then(() => {
    console.warn("[session] invalidating session", { reason });

    SESSION_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));

    runHandlers(apiCleanupHandlers);
    runHandlers(socketCleanupHandlers, { reason });
    runHandlers(authStateHandlers, { isAuth: false, user: {} });

    if (window.location.pathname !== redirectTo) {
      window.location.replace(redirectTo);
    }
  });

  return invalidationPromise;
};